import React, { Component } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Divider, Loader, Form, Modal } from 'semantic-ui-react';

class ModalShareLink extends Component {
  state = {
    showForm: this.props.showForm
  };

  componentWillReceiveProps = (nextProps) => {
    this.setState({ showForm: nextProps.showForm });
  };

  onCopy = () => {
    this.setState({ copied: true });
  };

  onCloseForm = (event) => {
    this.props.closeForm();
    event.preventDefault();
    this.setState({ showForm: false });
    this.setState({ copied: false });
  };

  renderPresentationTitle = () => {
    if (this.state.presentationSaved === 'new') {
      return <p>Presentation created.</p>;
    } else if (this.state.presentationSaved === 'update') {
      return <p>Presentation updated.</p>;
    }
    return null;
  };

  renderLoadingOrCopy = (urlString) => {
    if (urlString.length === 0) {
      return <Loader inline className="active" />;
    }
    return (
      <div>
        <a href={urlString} target="_new">
          {urlString}
        </a>
        <CopyToClipboard text={urlString} onCopy={this.onCopy}>
          <Form.Button size="small" floated="right">
            Copy
          </Form.Button>
        </CopyToClipboard>
        <Divider hidden />
        {this.state.copied ? <span>Copied</span> : null}
      </div>
    );
  };

  render() {
    return (
      <div>
        <Modal
          dimmer="inverted"
          open={this.state.showForm}
          onClose={this.onCloseForm}
          className="share-link-presentation-import"
        >
          <Modal.Header>Share Presentation</Modal.Header>
          <Modal.Content style={{ height: 'auto', overflow: 'hidden', textAlign: 'left' }}>
            {this.renderPresentationTitle()}
            {this.renderLoadingOrCopy(this.props.urlString)}
          </Modal.Content>
          <div />
        </Modal>
      </div>
    );
  }
}

export default ModalShareLink;



// WEBPACK FOOTER //
// ./src/screens/AdImport/AdImportComponents/ModalShareLink.js